export default __webpack_public_path__ + "static/media/PTA 12.ae1b4c7a.pdf";